import {
  AboutEventSkeleton,
  EventCarouselSkeleton,
  EventSpecsSkeleton,
  GetDirectionsSkeleton,
  PoliciesAccordionSkeleton
} from '../mainSection/components';

export function MainSectionSkeleton(): React.ReactNode {
  return (
    <section className='flex w-full'>
      <section className='mx-auto flex w-full max-w-7xl flex-col justify-between gap-6 p-6 md:flex-row'>
        <div className='w-full lg:w-[65%]'>
          <EventCarouselSkeleton />
          <AboutEventSkeleton />
          <PoliciesAccordionSkeleton />
        </div>

        <div className='w-full lg:w-[35%]'>
          <EventSpecsSkeleton />
          <GetDirectionsSkeleton />
        </div>
      </section>
    </section>
  );
}
